// @ts-ignore
import 'react-quill/dist/quill.snow.css';

import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import ReactQuill, { Value } from 'react-quill';

import { styles } from './rich-text-editor-v2.styles';

export interface IRichTextEditorV2Props {
  value: Value;
  onChange: ReactQuill.ReactQuillProps['onChange'];
  onBlur?: () => void;
  disabled?: boolean;
  placeholder?: string;
}

export const RichTextEditorV2 = ({
  disabled,
  onBlur,
  onChange,
  placeholder,
  value,
}: IRichTextEditorV2Props) => {
  const [editorId] = useState(() => `editor-${Math.random().toString(36).substring(2, 9)}`);
  const editorRef = useRef<ReactQuill>(null);

  useEffect(() => {
    const container = document.getElementById(editorId);

    const handleGlobalMouseDown = (e: MouseEvent) => {
      const target = e.target as HTMLElement;

      const isToolbar = target.closest('.ql-toolbar');
      const isTooltip = target.closest('.ql-tooltip');

      if (isToolbar || isTooltip) {
        if (target.tagName !== 'INPUT') {
          e.preventDefault();
        }
      }
    };

    if (container) {
      container.addEventListener('mousedown', handleGlobalMouseDown);
    }

    return () => {
      if (container) {
        container.removeEventListener('mousedown', handleGlobalMouseDown);
      }
    };
  }, [editorId]);

  const formats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
  ];

  const modules = {
    toolbar: [
      [{ header: [3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['link'],
      ['clean'],
    ],
  };

  const isEmpty = !value || value === '<p><br></p>';

  return (
    <Box
      className={`${disabled ? 'disabled' : ''} ${isEmpty ? 'empty' : ''}`}
      id={editorId}
      sx={styles.editorWrapper}
    >
      <ReactQuill
        ref={editorRef}
        bounds={`#${editorId} .ql-editor`}
        formats={formats}
        modules={modules}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={placeholder || 'Write your buying guide...'}
        readOnly={disabled}
        scrollingContainer="#layout-content-container"
        theme="snow"
        value={value || ''}
      />
    </Box>
  );
};
